export default __webpack_public_path__ + "static/media/feature-1.32384e6e.png";